module.exports = require("redux-logger");